export default {
  SET_PUSH_NOTIFICATION_CAMPAIGN_DETAILS(state, payload) {
    state[payload.key] = payload.value;
  },
  name(state, payload) {
    state.name = payload;
  },
  title(state, payload) {
    state.title = payload;
  },
  body(state, payload) {
    state.body = payload;
  },
  urltext(state, payload) {
    state.body = payload;
  },
  GET_ALL_REGISTERED_USERS(state, payload) {
    state[payload.key] = payload.value;
  },
  PUSH_NOTIFICATION_MEMBERS(state, payload) {
    state[payload.key] = payload.value;
  },
  GET_ALL_CAMPAIGN_REPORTS(state, payload) {
    state[payload.key] = payload.value;
  },
  GET_ALL_API_REPORTS(state, payload) {
    state[payload.key] = payload.value;
  },
  GET_ALL_NOTIFICATION_TEMPLATE(state, payload) {
    state.getAllNotificationTemplate = payload;
  },
  SET_PUSH_NOTIFICATION_TEMPLATE(state, payload) {
    state.createPushNotification = payload;
  },
};
